import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import boston__asset from "@/assets/restore/locations/boston.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Boston",
    serviceArea: "boston",
    address: "75 Arlington Street, Suite 500",
    img: boston__asset.url,
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=75+Arlington+Street+Boston+MA",
    to: "/locations/massachusetts/boston/",
  },
];

export const Route = createFileRoute("/locations/massachusetts/")({
  head: () => ({
    meta: [
      { title: "RESTORE Hair | Massachusetts Hair Transplants + Restoration" },
      {
        name: "description",
        content:
          "Get your hair back and RESTORE your confidence in Massachusetts with RESTORE Hair Transplants, offering FUE & No Shave Hair Restoration. Get a free consult!",
      },
      { property: "og:title", content: "Massachusetts Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Boston, Massachusetts and book a free consultation to learn about the FUE procedure.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/massachusetts/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/massachusetts/" }],
  }),
  component: () => <StateLocationsHub stateName="Massachusetts" h1="Massachusetts Hair Transplants" cities={cities} />,
});